<template>
  <iframe id="cloudIframe"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            src="cloud/cloud.html">
  </iframe>
</template>

<script>
export default {
  name: "CloudMap",
  data(){
    return {
    }
  },
  mounted() {
    this.showCloud()
  },
  methods:{
    showCloud() {
      let iframeDom = document.getElementById('cloudIframe')
      let content = iframeDom.contentWindow || iframeDom.contentDocument
      let doc = content.document
      let body = doc.body
      this.$http.get('/api/getCloudChart').then(res => {
        // this.cloudContent = res.data
        let html = res.data
        let htmlstr = html.toString()
        let sIndex = htmlstr.indexOf('<form')
        let eIndex = htmlstr.indexOf('</body')
        let bodystr = htmlstr.slice(sIndex, eIndex)
        var div = doc.createElement('div')
        div.innerHTML = bodystr
        body.appendChild(div)
      })
    }
  }
}
</script>

<style scoped lang="less">
.cloud-map{
  height: 100%;
  width: 100%;
}
</style>
